import React from 'react';
import CircleIcon from '@/icons/circle.svg';
import {
  IconTransferIn,
  IconTopologyStar3,
  IconEditCircle,
  IconLayersIntersect,
  IconProgressCheck,
  IconTransform,
  IconPackageExport,
} from '@tabler/icons-react';

export function OperationCardIcon({ isEnabled, operationName }: { isEnabled: boolean; operationName: string }) {
  if (operationName === 'Import') {
    return (
      <IconTransferIn
        style={{
          color: isEnabled ? 'var(--mantine-color-teal-6)' : 'var(--mantine-color-gray-3)',
        }}
      />
    );
  }
  if (operationName === 'Scene Graph Flattening') {
    return (
      <IconTopologyStar3
        style={{
          color: isEnabled ? 'var(--mantine-color-teal-6)' : 'var(--mantine-color-gray-3)',
        }}
      />
    );
  }
  if (operationName === '3D Edit') {
    return (
      <IconEditCircle
        style={{
          color: isEnabled ? 'var(--mantine-color-teal-6)' : 'var(--mantine-color-gray-3)',
        }}
      />
    );
  }
  if (operationName === 'Mesh Culling') {
    return (
      <IconLayersIntersect
        style={{
          color: isEnabled ? 'var(--mantine-color-teal-6)' : 'var(--mantine-color-gray-3)',
        }}
      />
    );
  }
  if (operationName === 'Optimize') {
    return (
      <IconProgressCheck
        style={{
          color: isEnabled ? 'var(--mantine-color-teal-6)' : 'var(--mantine-color-gray-3)',
        }}
      />
    );
  }
  if (operationName === 'Modifier') {
    return (
      <IconTransform
        style={{
          color: isEnabled ? 'var(--mantine-color-teal-6)' : 'var(--mantine-color-gray-3)',
        }}
      />
    );
  }
  if (operationName === 'Export') {
    return (
      <IconPackageExport
        style={{
          color: isEnabled ? 'var(--mantine-color-teal-6)' : 'var(--mantine-color-gray-3)',
        }}
      />
    );
  }
  return (
    <CircleIcon
      style={{
        color: isEnabled ? 'var(--mantine-color-teal-6)' : 'var(--mantine-color-gray-3)',
      }}
    />
  );
}
